import { render } from "./RecipePrint.vue?vue&type=template&id=cd5ddf3e"
import script from "./RecipePrint.vue?vue&type=script&lang=js"
export * from "./RecipePrint.vue?vue&type=script&lang=js"

import "./RecipePrint.vue?vue&type=style&index=0&id=cd5ddf3e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__